// /**
// * Checks browser is running on a native mobile device
// */
export const isDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (
    /windows phone/i.test(userAgent) ||
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
  ) {
    return true;
  }

  return false;
};

export const isEmpty = element => {
  if (element.textContent.trim() === '') {
    return true;
  }
};

export const isInViewport = element => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const checkTrustarc = (cookie, permit) => {
  if (cookie) {
    if (!(String(cookie)).includes(permit)) {
      return true;
    }

    return false;
  }
};

// for local development purposes
export const getFakeLocation = () => {
  if (window.location.hostname === 'localhost') {
    return {
      lat: 42.3612,
      lng: -71.0519,
      countryState: 'MA',
      zipCode: '02108'
    }
  }
  return {};
};

export const getCurrentPathnameWithoutLanguage = () => {
  const pathname = window.location.pathname;
  const language = pathname.split('/')[1];

  if (language === 'en' || language === 'fr') {
    return pathname.replace(`/${language}`, '');
  }

  return pathname;
}
